import { render, staticRenderFns } from "./TheSubscriptionForm.vue?vue&type=template&id=463a817e&scoped=true&"
import script from "./TheSubscriptionForm.vue?vue&type=script&lang=js&"
export * from "./TheSubscriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./TheSubscriptionForm.vue?vue&type=style&index=0&id=463a817e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463a817e",
  null
  
)

export default component.exports